function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M33.5 20A13.5 13.5 0 1120 6.5 13.49 13.49 0 0133.5 20zm-6.29 5.08l-1.62-3.3-3.23 1m-9.57-7.9l1.32 3.7 3.6-1.18m7.85 4.54a5.79 5.79 0 01-11.16-.41m-.09-3.12a5.82 5.82 0 0111.47.17"
}));